/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-07-06 16:23:08
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-11 19:57:41
 */
// 定义全局组件

import Vue from 'vue';
import BaseTable from './BaseTable';
import searchForms from './searchForms';
import multiTable from './multiTable';
import rdUI from '@rd/rd-ui';

Vue.component('BaseTable', BaseTable); //列表
Vue.component('yxPagination', rdUI.YxPagination); //分页器
Vue.component('yxSearch', searchForms); //筛选
Vue.component('multiTable', multiTable); //多tab
Vue.component('Search', rdUI.Search);
Vue.component('Panel', rdUI.Panel); // 面板组件
Vue.component('RdDataText', rdUI.RdDataText); // 数据文本组件
Vue.component('RdImg', rdUI.RdImg); // 图片组件
Vue.component('RdStatus', rdUI.RdStatus); // 状态组件
Vue.component('RdTableHead', rdUI.RdTableHead); // 表头单元格组件
Vue.component('RdTag', rdUI.RdTag); // 标签组件
Vue.component('RdText', rdUI.RdText); // 文本组件
Vue.component('RdButtonCheckGroup', rdUI.RdButtonCheckGroup); // 按钮组组件
Vue.component('RdPureCheckGroup', rdUI.RdPureCheckGroup); // 纯选项组组件
Vue.component('RdDetailInfoCard', rdUI.RdDetailInfoCard); // 商品详情卡片组件
Vue.component('RdTagGroup', rdUI.RdTagGroup); // 标签组组件
Vue.component('RdShopInfo', rdUI.RdShopInfo); // 店铺信息组件
Vue.component('MultiInput', rdUI.MultiInput); // 店铺信息组件
Vue.component('platformTab', rdUI.platformTab);
Vue.component('PlatformIcon', rdUI.PlatformIcon);
Vue.component('BreadCrumb', rdUI.BreadCrumb);
Vue.component('Empty', rdUI.Empty);
Vue.component('ExpanTip', rdUI.ExpanTip);
Vue.component('MultiDatePicker', rdUI.MultiDatePicker);
Vue.component('TableColumnCustom', rdUI.TableColumnCustom);
Vue.component('videoPlayer', rdUI.VideoPlayer);
Vue.component('YxAvatar', rdUI.YxAvatar);
Vue.component('LevelTag', rdUI.LevelTag);
Vue.component('SpVerify', rdUI.SpVerify);
// Vue.component('SubTabs', rdUI.SubTabs);
Vue.component('Tip', rdUI.Tip);
Vue.component('PlatformSelect', rdUI.PlatformSelect);
